import { Trans, useTranslation } from "react-i18next";
import FrontText from "../../FrontText";
import { Icon } from "@iconify/react";
import { useState } from "react";
import { Transition } from "@headlessui/react";
import WebpImage from "../WebpImage";
import { Link } from "@inertiajs/react";
import makePhoneNumber from "@/Helpers/makePhoneNumber";

const AccordionItem = ({ item, agents, components }) => {
    const { t, i18n } = useTranslation();
    const [hidden, setHidden] = useState(true);

    const currentLang = i18n.resolvedLanguage;
    const agent = agents.find(el => el.name == item.contactPerson);

    return (
        <div className="border-b-2 border-E9E9E9 mb-5 ">
            <button className="w-full text-left flex" onClick={() => setHidden(!hidden)}>
                <FrontText className="font-bold pb-5" textSize={`20/24-m-18/24`}>
                    <Trans i18nKey={item.heading} />
                </FrontText>
                <Icon icon={`mingcute:down-fill`} className={`ml-auto transition-all ease-in-out duration-300 ${!hidden ? 'rotate-180' : ''}`} width={26} />
            </button>
            <Transition
                show={!hidden}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="content my-5">
                    {item.content.text &&
                        <FrontText className="[&_p]:mb-5">
                            <Trans 
                                i18nKey={item.content.text}
                                components={components}
                            />
                        </FrontText>
                    }
                    {item.content.icons &&
                        <div className="flex xl:gap-x-20 sm:gap-x-10 gap-x-5 flex-wrap gap-y-10 sm:justify-between justify-center items-baseline mt-10 lg:mb-20 md:mb-15 mb-10">
                            {item.content.icons.map((icon, id) => (
                                <div className="text-center xl:w-[calc(25%_-_5rem)] sm:w-[calc(25%_-_2.5rem)] w-[calc(50%_-_1.25rem)] shrink-0" key={id}>
                                    <img src={`/storage/icons/${icon.icon}`} className="w-[93px] mx-auto" alt={icon.text} width={93} height={93} loading="lazy" />
                                    <FrontText className="my-5 font-semibold text-heading-blue">
                                        <Trans i18nKey={icon.text} />
                                    </FrontText>
                                    <FrontText className="font-medium text-black">
                                        <Trans i18nKey={icon.subtext} />
                                    </FrontText>
                                </div>
                            ))}
                        </div>
                    }
                    {agent &&
                        <div className={`flex md:gap-x-c30 gap-4 lg:mb-16 md:mb-12 mb-8 ${!item.content.icon ? 'xl:mt-c120 lg:mt-25 md:mt-20 mt-15' : ''}`}>
                            <WebpImage
                                pictureClassName="shrink-0"
                                lazy={true}
                                className='rounded-20 sm:w-[155px] sm:h-[155px] w-28 h-28 object-cover shrink-0'
                                sources={[
                                    {
                                        width: 1,
                                        path: `/storage/avatars/${agent.photo.substring(0, agent.photo.lastIndexOf('.'))}-400`,
                                        mime: agent.photo.split('.').pop(),
                                    },
                                ]}
                                alt={agent.name + ' - ' + currentLang === 'pl' && agent.position + currentLang === 'en' && agent.position_en}
                                fallback={`/storage/avatars/${agent.photo}`}
                                seo={{
                                    width: 155,
                                    height: 155,
                                }}
                            />
                            <div className="self-center">
                                <FrontText textSize={`20/29-m-14/20`} className="font-bold text-dark-blue">
                                    <p>{agent.name}</p>
                                </FrontText>
                                <FrontText textSize={`14/20-m-8/12`} className="font-bold text-yellow mb-5 uppercase">
                                    <p>
                                        {currentLang === 'pl' && agent.position}
                                        {currentLang === 'en' && agent.position_en}
                                    </p>
                                </FrontText>
                                <div className="flex">
                                    <div className="text-dark-blue">
                                        <a
                                            href={`mailto:${agent.email}`}
                                            className="mb-3 hover:text-orange hover:border-orange items-center transition-all ease-in-out duration-300 flex gap-c6"
                                        >
                                            <Icon
                                                className="shrink-0 p-1 border border-inherit rounded-full"
                                                icon="material-symbols:mail-outline-rounded"
                                                height={28}
                                                width={28}
                                            />
                                            <FrontText textSize="14/20-m-10/14" className="overflow-wrap-anywhere">
                                                {agent.email}
                                            </FrontText>
                                        </a>

                                        <a
                                            href={makePhoneNumber(agent.phone)}
                                            className="mb-3 hover:text-orange hover:border-orange items-center transition-all ease-in-out duration-300 flex gap-c6"
                                        >
                                            <Icon
                                                className="shrink-0 p-1 border border-inherit rounded-full"
                                                icon="ic:baseline-phone"
                                                height={28}
                                                width={28}
                                            />
                                            <FrontText textSize="14/20-m-10/14">
                                                {agent.phone}
                                            </FrontText>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {item.updateDate &&
                        <FrontText textSize="14/20" className="mb-10">
                            <Trans i18nKey={item.updateDate}/>
                        </FrontText>
                    }
                </div>
            </Transition>
        </div>
    )
}

export default AccordionItem;